export default __webpack_public_path__ + "static/drukte-cd916ae2960cb8ad58670e1dd9024d41.png";